import { Modal as SemanticUIModal } from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import React, { Suspense } from 'react';

import { featuresPageModals } from '../../../../components/features/components/modals';
import useModalConfig from '../../hooks/modal-config';
import { toggleActiveModal } from '../reducers';
import MobileModal from './mobile';
import Loader from '../loader';

const modals = {
  ...featuresPageModals
};

const Modal = () => {
	const { activeModal } = useSelector((state) => state.layout);
	const dispatch = useDispatch();

  const closeModal = () => dispatch(toggleActiveModal(''));
  const modal = modals?.[activeModal];
  
  const { viewport, styles } = useModalConfig(modal?.config);
  const ActiveModalComponent = modal?.component;

	if (!ActiveModalComponent) return null;

  return (
    <Suspense fallback={<Loader />}>
      {viewport !== 'sm' ? (
        <SemanticUIModal style={styles} onClose={closeModal} open={!!activeModal}>
          <ActiveModalComponent onClose={closeModal} />
        </SemanticUIModal>
      ) : (
        <MobileModal open={!!activeModal} onClose={closeModal}>
          <ActiveModalComponent onClose={closeModal} />
        </MobileModal>
      )}
    </Suspense>
  );
};

export default Modal;